import MerchantHomePage from './MerchantHomePage'

export default MerchantHomePage
